import React from "react";
import { HiOutlineStar } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneBestOfAfrica } from "../../../lib/sysNavigation/SysNavigation";

type BestOfAfricaRow = {
  attraction_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<BestOfAfricaRow>
    type={_TYPES_.BESTOFAFRICA}
    title="Best of Africa"
    subtitle="Highlighted entries featured on the public site."
    icon={<HiOutlineStar className="h-5 w-5" />}
    addRoute="/data/bestofafrica/add"
    editRoute="/data/bestofafrica/edit"
    pushOne={pushOneBestOfAfrica}
    dataKey="bestOfAfrica"
    countKey="bestOfAfricaCount"
    idField="attraction_id"
  />
);

export default Overview;
